export const configurableSelectStyles = {
  menu: baseStyles => ({
    ...baseStyles,
    marginBottom: 0,
    marginTop: 0,
    maxWidth: 'calc(100vw - 2rem)',
    minWidth: '100%',
    width: 'min(24rem, calc(100vw - 3rem))'
  }),
  menuList: baseStyles => ({
    ...baseStyles,
    paddingTop: 2,
    paddingBottom: 2
  }),
  option: baseStyles => ({
    ...baseStyles,
    fontSize: 15,
    lineHeight: '20px',
    overflow: 'hidden',
    padding: '4px 8px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  })
}
